/**
 * External Imports
 */
import { FC } from 'react';

/**
 * Style Imports
 */
import { StyledAddBtn } from './AddBtn.styles';

const AddBtn: FC<{ content: string; handleAddClick: any }> = ({
  content,
  handleAddClick
}) => {
  return (
    <StyledAddBtn
      id={`Add-Button-${content}`}
      className="me-3"
      color="blue"
      data-testid={`${content.replace(/\s+/g, '-').toLowerCase()}-add-button`}
      icon="add"
      kind="primary"
      minWidth={content.length}
      size="small"
      onClick={() => handleAddClick(content)}
    >
      {content}
    </StyledAddBtn>
  );
};

export default AddBtn;
